"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var psdReader_1 = require("./psdReader");

var base64_js_1 = require("base64-js");

function offsetForChannel(channelId) {
  switch (channelId) {
    case 0
    /* Red */
    :
      return 0;

    case 1
    /* Green */
    :
      return 1;

    case 2
    /* Blue */
    :
      return 2;

    case -1
    /* Transparency */
    :
      return 3;

    default:
      return channelId + 1;
  }
}

exports.offsetForChannel = offsetForChannel;

function toArray(value) {
  var result = new Array(value.length);

  for (var i = 0; i < value.length; i++) {
    result[i] = value[i];
  }

  return result;
}

exports.toArray = toArray;

function readColor(reader) {
  return toArray(psdReader_1.readBytes(reader, 10));
}

exports.readColor = readColor;

function hasAlpha(data) {
  var size = data.width * data.height * 4;

  for (var i = 3; i < size; i += 4) {
    if (data.data[i] !== 255) {
      return true;
    }
  }

  return false;
}

exports.hasAlpha = hasAlpha;

function isRowEmpty(_a, y, left, right) {
  var data = _a.data,
      width = _a.width;
  var start = (y * width + left) * 4 + 3 | 0;
  var end = start + (right - left) * 4 | 0;

  for (var i = start; i < end; i = i + 4 | 0) {
    if (data[i] !== 0) {
      return false;
    }
  }

  return true;
}

function isColEmpty(_a, x, top, bottom) {
  var data = _a.data,
      width = _a.width;
  var stride = width * 4 | 0;
  var start = top * stride + x * 4 + 3 | 0;

  for (var y = top, i = start; y < bottom; y++, i = i + stride | 0) {
    if (data[i] !== 0) {
      return false;
    }
  }

  return true;
}

function trimData(data) {
  var top = 0;
  var left = 0;
  var right = data.width;
  var bottom = data.height;

  while (top < bottom && isRowEmpty(data, top, left, right)) {
    top++;
  }

  while (bottom > top && isRowEmpty(data, bottom - 1, left, right)) {
    bottom--;
  }

  while (left < right && isColEmpty(data, left, top, bottom)) {
    left++;
  }

  while (right > left && isColEmpty(data, right - 1, top, bottom)) {
    right--;
  }

  return {
    top: top,
    left: left,
    right: right,
    bottom: bottom
  };
}

function getLayerDimentions(_a) {
  var canvas = _a.canvas;

  if (canvas && canvas.width && canvas.height) {
    return {
      width: canvas.width,
      height: canvas.height
    };
  } else {
    return {
      width: 0,
      height: 0
    };
  }
}

exports.getLayerDimentions = getLayerDimentions;

function getChannels(tempBuffer, layer, background, options) {
  var layerData = getLayerChannels(tempBuffer, layer, background, options);
  var mask = layer.mask;

  if (mask && mask.canvas) {
    var _a = mask.top,
        top_1 = _a === void 0 ? 0 : _a,
        _b = mask.left,
        left = _b === void 0 ? 0 : _b,
        _c = mask.right,
        right = _c === void 0 ? 0 : _c,
        _d = mask.bottom,
        bottom = _d === void 0 ? 0 : _d;

    var _e = getLayerDimentions(mask),
        width = _e.width,
        height = _e.height;

    if (width && height) {
      right = left + width;
      bottom = top_1 + height;
      var context_1 = mask.canvas.getContext('2d');
      var data = context_1.getImageData(0, 0, width, height);
      var buffer = writeDataRLE(tempBuffer, data, width, height, [0]);
      layerData.mask = {
        top: top_1,
        left: left,
        right: right,
        bottom: bottom
      };
      layerData.channels.push({
        channelId: -2
        /* UserMask */
        ,
        compression: 1
        /* RleCompressed */
        ,
        buffer: buffer,
        length: 2 + buffer.length
      });
    }
  }

  return layerData;
}

exports.getChannels = getChannels;

function getLayerChannels(tempBuffer, layer, background, options) {
  var canvas = layer.canvas;
  var _a = layer.top,
      top = _a === void 0 ? 0 : _a,
      _b = layer.left,
      left = _b === void 0 ? 0 : _b,
      _c = layer.right,
      right = _c === void 0 ? 0 : _c,
      _d = layer.bottom,
      bottom = _d === void 0 ? 0 : _d;
  var channels = [{
    channelId: -1
    /* Transparency */
    ,
    compression: 0
    /* RawData */
    ,
    buffer: undefined,
    length: 2
  }];

  var _e = getLayerDimentions(layer),
      width = _e.width,
      height = _e.height;

  if (!canvas || !width || !height) {
    right = left;
    bottom = top;
    return {
      layer: layer,
      top: top,
      left: left,
      right: right,
      bottom: bottom,
      channels: channels
    };
  }

  right = left + width;
  bottom = top + height;
  var context = canvas.getContext('2d');
  var data = context.getImageData(0, 0, width, height);

  if (options.trimImageData) {
    var trimmed = trimData(data);

    if (trimmed.left !== 0 || trimmed.top !== 0 || trimmed.right !== data.width || trimmed.bottom !== data.height) {
      left += trimmed.left;
      top += trimmed.top;
      right -= data.width - trimmed.right;
      bottom -= data.height - trimmed.bottom;
      width = right - left;
      height = bottom - top;

      if (!width || !height) {
        return {
          layer: layer,
          top: top,
          left: left,
          right: right,
          bottom: bottom,
          channels: channels
        };
      }

      data = context.getImageData(trimmed.left, trimmed.top, width, height);
    }
  }

  var channelIds = [0
  /* Red */
  , 1
  /* Green */
  , 2
  /* Blue */
  ];

  if (!background || hasAlpha(data) || layer.mask) {
    channelIds.unshift(-1
    /* Transparency */
    );
  }

  channels = channelIds.map(function (channel) {
    var offset = offsetForChannel(channel);
    var buffer = writeDataRLE(tempBuffer, data, width, height, [offset]);
    return {
      channelId: channel,
      compression: 1
      /* RleCompressed */
      ,
      buffer: buffer,
      length: 2 + buffer.length
    };
  });
  return {
    layer: layer,
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    channels: channels
  };
}

exports.getLayerChannels = getLayerChannels;

function resetCanvas(_a) {
  var width = _a.width,
      height = _a.height,
      data = _a.data;
  var size = width * height | 0;
  var buffer = new Uint32Array(data.buffer);

  for (var p = 0; p < size; p = p + 1 | 0) {
    buffer[p] = 0xff000000;
  }
}

exports.resetCanvas = resetCanvas;

function decodeBitmap(input, output, width, height) {
  for (var y = 0, p = 0, o = 0; y < height; y++) {
    for (var x = 0; x < width;) {
      var b = input[o++];

      for (var i = 0; i < 8 && x < width; i++, x++) {
        var v = b & 0x80 ? 0 : 255;
        b = b << 1;
        output[p++] = v;
        output[p++] = v;
        output[p++] = v;
        output[p++] = 255;
      }
    }
  }
}

exports.decodeBitmap = decodeBitmap;

function writeDataRaw(data, offset, width, height) {
  if (!width || !height) return undefined;
  var array = new Uint8Array(width * height);

  for (var i = 0; i < array.length; i++) {
    array[i] = data.data[i * 4 + offset];
  }

  return array;
}

exports.writeDataRaw = writeDataRaw;

function readDataRaw(reader, pixelData, offset, width, height) {
  var size = width * height;
  var buffer = psdReader_1.readBytes(reader, size);

  if (pixelData && offset < 4) {
    var data = pixelData.data;

    for (var i = 0, p = offset | 0; i < size; i++, p = p + 4 | 0) {
      data[p] = buffer[i];
    }
  }
}

exports.readDataRaw = readDataRaw;

function writeDataRLE(buffer, _a, width, height, offsets) {
  var data = _a.data;
  if (!width || !height) return undefined;
  var stride = 4 * width | 0;
  var ol = 0;
  var o = offsets.length * 2 * height | 0;

  for (var _i = 0, offsets_1 = offsets; _i < offsets_1.length; _i++) {
    var offset = offsets_1[_i];

    for (var y = 0, p = offset | 0; y < height; y++) {
      var strideStart = y * stride | 0;
      var strideEnd = strideStart + stride | 0;
      var lastIndex = strideEnd + offset - 4 | 0;
      var lastIndex2 = lastIndex - 4 | 0;
      var startOffset = o;

      for (p = strideStart + offset | 0; p < strideEnd; p = p + 4 | 0) {
        if (p < lastIndex2) {
          var value1 = data[p];
          p = p + 4 | 0;
          var value2 = data[p];
          p = p + 4 | 0;
          var value3 = data[p];

          if (value1 === value2 && value1 === value3) {
            var count = 3;

            while (count < 128 && p < lastIndex && data[p + 4 | 0] === value1) {
              count = count + 1 | 0;
              p = p + 4 | 0;
            }

            buffer[o++] = 1 - count;
            buffer[o++] = value1;
          } else {
            var countIndex = o;
            var writeLast = true;
            var count = 1;
            buffer[o++] = 0;
            buffer[o++] = value1;

            while (p < lastIndex && count < 128) {
              p = p + 4 | 0;
              value1 = value2;
              value2 = value3;
              value3 = data[p];

              if (value1 === value2 && value1 === value3) {
                p = p - 12 | 0;
                writeLast = false;
                break;
              } else {
                count++;
                buffer[o++] = value1;
              }
            }

            if (writeLast) {
              if (count < 127) {
                buffer[o++] = value2;
                buffer[o++] = value3;
                count += 2;
              } else if (count < 128) {
                buffer[o++] = value2;
                count++;
                p = p - 4 | 0;
              } else {
                p = p - 8 | 0;
              }
            }

            buffer[countIndex] = count - 1;
          }
        } else if (p === lastIndex) {
          buffer[o++] = 0;
          buffer[o++] = data[p];
        } else {
          // p === lastIndex2
          buffer[o++] = 1;
          buffer[o++] = data[p];
          p = p + 4 | 0;
          buffer[o++] = data[p];
        }
      }

      var length_1 = o - startOffset;
      buffer[ol++] = length_1 >> 8 & 0xff;
      buffer[ol++] = length_1 & 0xff;
    }
  }

  return buffer.slice(0, o);
}

exports.writeDataRLE = writeDataRLE;

function readDataRLE(reader, pixelData, _width, height, step, offsets) {
  var lengths = new Uint16Array(offsets.length * height);
  var data = pixelData && pixelData.data;

  for (var o = 0, li = 0; o < offsets.length; o++) {
    for (var y = 0; y < height; y++, li++) {
      lengths[li] = psdReader_1.readUint16(reader);
    }
  }

  for (var c = 0, li = 0; c < offsets.length; c++) {
    var offset = offsets[c] | 0;
    var extra = c > 3 || offset > 3;

    if (!data || extra) {
      for (var y = 0; y < height; y++, li++) {
        psdReader_1.skipBytes(reader, lengths[li]);
      }
    } else {
      for (var y = 0, p = offset | 0; y < height; y++, li++) {
        var length_2 = lengths[li];
        var buffer = psdReader_1.readBytes(reader, length_2);

        for (var i = 0; i < length_2; i++) {
          var header = buffer[i];

          if (header >= 128) {
            var value = buffer[++i];
            header = 256 - header | 0;

            for (var j = 0; j <= header; j = j + 1 | 0) {
              data[p] = value;
              p = p + step | 0;
            }
          } else {
            // header < 128
            for (var j = 0; j <= header; j = j + 1 | 0) {
              data[p] = buffer[++i];
              p = p + step | 0;
            }
          }
          /* istanbul ignore if */


          if (i >= length_2) {
            throw new Error("Invalid RLE data: exceeded buffer size " + i + "/" + length_2);
          }
        }
      }
    }
  }
}

exports.readDataRLE = readDataRLE;
/* istanbul ignore next */

exports.createCanvas = function () {
  throw new Error('Canvas not initialized, use initializeCanvas method to set up createCanvas method');
};
/* istanbul ignore next */


exports.createCanvasFromData = function () {
  throw new Error('Canvas not initialized, use initializeCanvas method to set up createCanvasFromData method');
};
/* istanbul ignore if */


if (typeof document !== 'undefined') {
  exports.createCanvas = function (width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  };

  exports.createCanvasFromData = function (data) {
    var image = new Image();
    image.src = 'data:image/jpeg;base64,' + base64_js_1.fromByteArray(data);
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext('2d').drawImage(image, 0, 0);
    return canvas;
  };
}

function initializeCanvas(createCanvasMethod, createCanvasFromDataMethod) {
  exports.createCanvas = createCanvasMethod;
  exports.createCanvasFromData = createCanvasFromDataMethod || exports.createCanvasFromData;
}

exports.initializeCanvas = initializeCanvas;